import { ChangeDetectorRef, AfterViewInit, Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ViewChild, ChangeDetectionStrategy, OnDestroy, ApplicationRef, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckBoxModule, InputsModule } from '@progress/kendo-angular-inputs';
import { ComboBoxComponent, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { UploadModule } from '@progress/kendo-angular-upload';
import { DateInputsModule, FormatSettings } from '@progress/kendo-angular-dateinputs';
import { FormsModule } from '@angular/forms';
import { GridService } from 'app/services/grid.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FileManagerComponent } from '../file-manager/file-manager.component';
import { DrakeFilePreviewComponent } from '../drake-file-preview/drake-file-preview.component';
import { TranslocoPipe } from '@ngneat/transloco';
import { EditorModule } from "@progress/kendo-angular-editor";
import { MapModule } from '@progress/kendo-angular-map';
import { TileUrlTemplateArgs } from "@progress/kendo-angular-map";
import { ListBoxModule, ListBoxToolbarConfig } from "@progress/kendo-angular-listbox";
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { DrakeMatrixComponent } from '../drake-matrix/drake-matrix.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { BrowserModule } from '@angular/platform-browser';
import { RecaptchaComponent } from 'ng-recaptcha';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-drake-field',
  templateUrl: './drake-field.component.html',
  styleUrls: ['./drake-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    InputsModule,
    CheckBoxModule,
    DropDownsModule,
    UploadModule,
    DateInputsModule,
    FormsModule,
    MatDialogModule,
    MatIconModule,
    DrakeFilePreviewComponent,
    EditorModule,
    MapModule,
    ListBoxModule,
    TranslocoPipe,
    MonacoEditorModule,
    HttpClientModule,
    DrakeMatrixComponent,
    RecaptchaModule,
    TranslocoPipe
  ]
})
export class DrakeFieldComponent implements AfterViewInit, OnDestroy {

  @Input() public fieldConfig: any;
  @Input() public baseData: any;
  @Input() readonly: boolean = false;
  @Input() public mode: 'DEFAULT' | 'KPI' = 'DEFAULT';
  @Output() public valueChanged: EventEmitter<{ field: string, value: any, isValid: boolean }> = new EventEmitter<any>();
  @ViewChild('captchaRef') captchaRef: RecaptchaComponent; // Add ViewChild for RecaptchaComponent
  @ViewChild("combo1") public combo1: ComboBoxComponent;
  @ViewChild("combo2") public combo2: ComboBoxComponent;
  @ViewChild("combo3") public combo3: ComboBoxComponent;
  private isNew: boolean = false;
  public captchaID: any;
  public captchaField: any;
  public captchaResponse: string | null = null;
  private userId: string;
  private baseDataSub: Subscription;
  public refreshing: boolean = false;

  public virtual: any = {
    itemHeight: 28,
  };

  public format: FormatSettings = {
    displayFormat: "dd/MM/yyyy",
    inputFormat: "dd/MM/yy",
  };

  public options: any[];
  public cascadeOptions: any[];
  public originalOptions: any[];

  //location/map
  public markers: any[] = [];
  public locationCenter: any = { lat: 0, lon: 0 };
  public searchQuery: string = '';
  public searchResults: any[] = [];
  public location: { lat: number, lon: number, description: string } = { lat: 0, lon: 0, description: '' };
  public isValid: boolean = true;

  tileSubdomains = ["a", "b", "c"];

  tileUrl = (e: TileUrlTemplateArgs): string =>
    `https://${e.subdomain}.tile.openstreetmap.org/${e.zoom}/${e.x}/${e.y}.png`;


  //listbox
  public arrayData: any[] = [];
  public selectedItems: any[] = [];
  public newItem: string = '';
  public previousArrayDataLength: number = 0;
  public toolbarSettings: ListBoxToolbarConfig = {
    position: "right",
    tools: ["moveUp", "moveDown", "remove"],
  };


  //CodeEditor
  public editorContent: string;

  editorOptions = {
    theme: 'vs-dark',
    language: 'json',
    automaticLayout: true
  };

  //slider
  public sliderOptions: any = {};

  //Masked Textbox
  public mask: string = "(999) 000-00-00-00";
  private optionLoaded: boolean = false;


  constructor(private cdRef: ChangeDetectorRef, public translocoPipe: TranslocoPipe,
    private gridService: GridService, private drakeSharedService: DrakeSharedService, public dialog: MatDialog, private http: HttpClient,
    private zone: NgZone) {
    //console.log('DrakeFieldComponent initialized');
    if (location.pathname.split('/').slice(-1).toString() == 'f')
      this.isNew = true;
  }

  onCaptchaResolved(captchaResponse: string | null, columnCode: string) {
    // Controllo se il captcha è scaduto
    if (captchaResponse === null) {
      console.warn('Captcha scaduto. L\'utente deve reinserire il captcha.');
      this.baseData[columnCode] = null;  // Resetto il valore del captcha
      this.onChange();
      return;
    }


    this.captchaResponse = captchaResponse;

    this.validateCaptcha(captchaResponse, columnCode);
  }


  // Metodo per validare il captcha con il backend
  validateCaptcha(captchaToken: string, columnCode: string) {

    const url = `${environment.apiUrl}api/Auth/verify-recaptcha`


    this.http.post(url, { RecaptchaToken: captchaToken }).subscribe((response: any) => {

      if (response.status == "OK") {
        console.log("Captcha validato con successo!");
      } else {
        console.error("Captcha non valido", response.errors);
      }
      this.baseData[columnCode] = response.status;
      this.onChange();
    });
  }

  ngOnInit() {
    if (this.fieldConfig.fieldControlType === 'DROPDOWNLIST' || this.fieldConfig.fieldControlType === 'DRPLISTBOX' || this.fieldConfig.fieldControlType === 'RADIO') {
      console.log(this.fieldConfig.fieldCode);
      //if (this.fieldConfig.fieldCode == "ALBOFORNITORI.StatoAnagrafica")
      //  debugger;
      this.loadDropdownOptions();
    }
    if (this.baseData[this.fieldConfig.columnCode] === null || this.baseData[this.fieldConfig.columnCode] === '') {
      this.baseData[this.fieldConfig.columnCode] = undefined;
    }
    const userObj = JSON.parse(localStorage.getItem('user'));
    this.userId = userObj.id;

    this.baseDataSub = this.drakeSharedService.baseData$.subscribe(data => this.cdRef.markForCheck());
  }

  ngOnDestroy(): void {
    if (this.baseDataSub)
      this.baseDataSub.unsubscribe();
  }

  loadDropdownOptions() {
    if (this.drakeSharedService.drpOptions[this.fieldConfig.fieldCode]) {
      this.options = this.drakeSharedService.drpOptions[this.fieldConfig.fieldCode];
    }
    else {
      this.optionLoaded = true;
      this.gridService.getDropDownValues(this.fieldConfig.fieldCode).subscribe(
        (result: any[]) => {
          this.options = result;
          this.drakeSharedService.drpOptions[this.fieldConfig.fieldCode] = this.options;
        },
        (error) => {
          console.error('Error loading dropdown options:', error);
        }
      );
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    
    if (changes['fieldConfig']?.currentValue) {
      // reset SOLO ciò che dipende dal campo (evita sporco tra domande)
      this.options = [];
      this.cascadeOptions = [];
      this.originalOptions = [];

      // ricarica subito le opzioni (cache già pronta)
      if (this.fieldConfig?.fieldControlType === 'DROPDOWNLIST'
        || this.fieldConfig?.fieldControlType === 'DRPLISTBOX'
        || this.fieldConfig?.fieldControlType === 'RADIO') {

        this.loadDropdownOptions();      // prende da drpOptions subito
      }

      // se ti serve la logica extra (datetime, slider, ecc.)
      this.loadFields();

      // OnPush => forza update view
      this.cdRef.markForCheck();
    }

    if (changes['baseData']?.currentValue) {
      this.loadFields();
      this.cdRef.markForCheck();
    }

    if (changes['readonly'] !== undefined) {
      this.updateReadOnlyState();
      this.cdRef.markForCheck();
    }

    if (changes.baseData && changes.baseData.currentValue) {
      //console.log("base data cambiato FIELD COMPONENT");
      this.loadFields();

    }

    if (changes.readonly != undefined) {
      this.updateReadOnlyState();
    }

  }

  private updateReadOnlyState() {
    if (this.fieldConfig) {
      //this.fieldConfig.readonly = this.readonly || this.fieldConfig.readonly;

      // Aggiorna lo stato di sola lettura per i controlli specifici
      if (this.fieldConfig.fieldControlType === 'TEXTBOX' || this.fieldConfig.fieldControlType === 'TEXTAREA') {
        this.fieldConfig.disabled = this.readonly;
      }



    }
  }

  ngAfterViewInit(): void {
    this.loadFields();
    //debugger;
  }


  loadFields() {
    //console.log('entro in load fields')
    if (this.baseData) {
      if (!this.baseData[this.fieldConfig.columnCode])
        this.baseData[this.fieldConfig.columnCode] = null;
      if (this.readonly == true && this.fieldConfig) {
        //this.fieldConfig.readonly = true;
      }
      //console.log('imposto valori null')

    } else {
      console.error("BaseData or FieldConfig is undefined");
      this.cdRef.detectChanges(); // Ensure changes are detected
      return;
    }


    // Initialize the Kendo Captcha widget
    //$('#captcha').kendoCaptcha({
    //    error: function (data) {
    //        console.log(data);
    //    },
    //    handler: `${environment.apiUrl}api/Auth/resetCaptcha`,
    //    audioHandler: `${environment.apiUrl}api/Auth/audioCaptcha`,
    //    validationHandler: `${environment.apiUrl}api/Auth/validateCaptcha`,
    //});

    var c = setInterval(() => {
      if (this.fieldConfig.fieldDbType == 'DATETIME') {
        if (typeof this.baseData[this.fieldConfig.columnCode] == 'string') {
          try {

            this.baseData[this.fieldConfig.columnCode] = new Date(this.baseData[this.fieldConfig.columnCode]);

            clearInterval(c);
          }
          catch (ex) {
            console.log('XYZ_ERROR', ex)
          }
        }
        else if (typeof this.baseData[this.fieldConfig.columnCode] == 'object')
          clearInterval(c);
      }
      else if((this.fieldConfig.fieldControlType == 'DROPDOWNLIST' || this.fieldConfig.fieldControlType === 'DRPLISTBOX' || this.fieldConfig.fieldControlType === 'RADIO' )){
        if(this.originalOptions && this.fieldConfig.drpFilter){
            var baseData = this.baseData;
            debugger;
            this.cascadeOptions = this.originalOptions.filter(item => eval(this.fieldConfig.drpFilter));
            this.options = this.cascadeOptions;
            clearInterval(c);
        }
      }
      else
        clearInterval(c);
    }, 1000);

    if (this.fieldConfig.fieldControlType == 'DROPDOWNLIST' || this.fieldConfig.fieldControlType === 'DRPLISTBOX' || this.fieldConfig.fieldControlType === 'RADIO') {
      setTimeout(() => {
        if (this.drakeSharedService.drpOptions[this.fieldConfig.fieldCode]) {
          this.options = this.drakeSharedService.drpOptions[this.fieldConfig.fieldCode];
          this.cascadeOptions = JSON.parse(JSON.stringify(this.options));
          this.originalOptions = this.options;
        }
        else {
          debugger;
          this.gridService.getDropDownValues(this.fieldConfig.fieldCode).subscribe(result => {
            this.options = JSON.parse(JSON.stringify(result));
            this.cascadeOptions = JSON.parse(JSON.stringify(result));
            this.originalOptions = result;
            this.drakeSharedService.drpOptions[this.fieldConfig.fieldCode] = this.options;
          });
        }
      }, 1000);
    }

    if (this.fieldConfig.fieldControlType == 'MATRIX') {
      this.baseData[this.fieldConfig.columnCode] = [];
    }

    if (this.fieldConfig.fieldDbType == 'LOCATION') {

      setTimeout(() => {
        this.initializeLocation();
      }, 2500);
    }

    if (this.fieldConfig.fieldDbType == 'ARRAY') {
      setTimeout(() => {

        if ((this.fieldConfig.fieldControlType === 'LISTBOX' || this.fieldConfig.fieldControlType === 'DRPLISTBOX') && this.baseData[this.fieldConfig.columnCode]) {
          this.arrayData = this.baseData[this.fieldConfig.columnCode].map((item: any, index: number) => ({
            content: item,
            index: index
          }));
        }
        console.log("array Data: ", this.arrayData);
      }, 1000);
    }

    if (this.fieldConfig.fieldDbType == 'OBJECT') {
      setTimeout(() => {
        if (this.fieldConfig.fieldControlType === 'CODEEDITOR' && this.baseData[this.fieldConfig.columnCode]) {
          this.loadFieldObjectIntoEditor();
        }
      }, 1000);
    }

    if (this.fieldConfig.fieldDbType == 'BOOL') {
      setTimeout(() => {
        if (this.fieldConfig.fieldControlType === 'CHECKBOX' && this.baseData[this.fieldConfig.columnCode]) {
          if (this.baseData[this.fieldConfig.columnCode] == null)
            this.baseData[this.fieldConfig.columnCode] = this.baseData[this.fieldConfig.columnCode] || false;
        }
      }, 1000);
    }

    if (this.fieldConfig.fieldDbType == 'DECIMAL') {
      setTimeout(() => {
        if (this.fieldConfig.fieldControlType === 'RATING') {
          this.baseData[this.fieldConfig.columnCode] = this.baseData[this.fieldConfig.columnCode] || 0;
        }
      }, 1000);
    }

    if (this.fieldConfig.fieldDbType == 'DECIMAL') {
      setTimeout(() => {
        if (this.fieldConfig.fieldControlType === 'SLIDER') {
          //console.log(this.fieldConfig.fieldControlFormat)
          this.sliderOptions = JSON.parse(this.fieldConfig.fieldControlFormat);
          this.baseData[this.fieldConfig.columnCode] = this.baseData[this.fieldConfig.columnCode] || 0;
        }
      }, 1000);
    }

    // Segue il resto della funzione.
    if (this.fieldConfig.fieldDbType != 'STRING' || this.fieldConfig.fieldControlType === 'DROPDOWNLIST' || this.fieldConfig.fieldControlType === 'DRPLISTBOX' || this.fieldConfig.fieldControlType === 'RADIO') {
      setInterval(() => {
        this.cdRef.detectChanges();
      }, 2000);
    }

    this.cdRef.detectChanges();
    //console.log('Dati passati all\'editor:', this.baseData);
  }


  // Map Field
  onChange() {

    //console.log('onChange called for', this.fieldConfig.columnCode);
    this.cdRef.markForCheck();
    if (!this.fieldConfig.columnCode) {
      console.error("Field configuration is missing the column code.");
      return;
    }
    const obj = {
      field: this.fieldConfig.columnCode,
      value: this.baseData[this.fieldConfig.columnCode],
      isValid: this.fieldConfig.isValid
    };
    //console.log('Emitting value change:', obj);
    this.valueChanged.emit(obj);

    this.drakeSharedService.baseData$.next(obj)


  }

  onFieldButtonClick(cfg: any): void {
    // Notifica verso l’esterno (se serve)
    // Oppure gestisci qui l’azione
    if (cfg?.fieldFormula) {
      eval(cfg.fieldFormula);
    }

  }


  onMatrixDataChanged(event: any) {
    this.baseData[this.fieldConfig.columnCode] = event;
    this.onChange(); // Call onChange to emit valueChanged
  }


  onMapClick(event: any) {
    const location = event.location;
    this.location.lat = location.lat;
    this.location.lon = location.lng;
    this.markers = [{ location: [location.lat, location.lng] }];
    this.onChange();
  }

  initializeLocation() {
    if (this.baseData[this.fieldConfig.columnCode]) {
      const locationData = this.baseData[this.fieldConfig.columnCode];
      this.location.lat = locationData.lat || environment.locationDefaults.lat;
      this.location.lon = locationData.lon || environment.locationDefaults.lon;
      this.location.description = locationData.description || '';
      this.locationCenter = [this.location.lat, this.location.lon];
      this.markers = [{ location: [this.location.lat, this.location.lon] }];
      this.searchQuery = this.location.description;
    }
    else {
      this.location.lat = environment.locationDefaults.lat;
      this.location.lon = environment.locationDefaults.lon;
      this.location.description = '';
      this.locationCenter = [this.location.lat, this.location.lon];
    }
  }

  ensurePrimitiveValue(value: any): any {
    if (typeof value === 'object' && value !== null) {
      return value.value || value.id || null;
    }
    return value;
  }

  onDropdownChange(event: any) {
    this.baseData[this.fieldConfig.columnCode] = this.ensurePrimitiveValue(event);

    this.onChange();
  }

  onSearch(event: any) {
    this.searchQuery = event;
    if (this.searchQuery.trim() === '') {
      this.clearLocationFilter();
      return;
    }
    if (this.searchQuery.length > 2) {
      const url = `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&q=${this.searchQuery}`;
      this.http.get(url).subscribe((results: any) => {
        console.log("Nominatim API result:", results);
        this.searchResults = results.map((result: any) => ({
          formatted_address: result.display_name,
          lat: parseFloat(result.lat),
          lon: parseFloat(result.lon),
          address_details: result.address // This includes house number, street, city, etc.
        }));
      });
    }
  }


  onSearchSelect(event: any) {
    this.searchQuery = event;
    const selectedLocation = this.searchResults.find(result => result.formatted_address === event);
    if (selectedLocation) {
      this.locationCenter = [selectedLocation.lat, selectedLocation.lon];
      this.markers = [{ location: [selectedLocation.lat, selectedLocation.lon] }];
      this.location.lat = selectedLocation.lat;
      this.location.lon = selectedLocation.lon;
      this.location.description = selectedLocation.formatted_address;

      if (this.baseData) {
        this.baseData[this.fieldConfig.columnCode] = {
          lat: selectedLocation.lat,
          lon: selectedLocation.lon,
          description: selectedLocation.formatted_address
        };
        console.log("location salvata:", this.baseData[this.fieldConfig.columnCode]);
      }

      this.onChange();
    }
  }

  clearLocationFilter() {
    this.searchQuery = '';
    this.searchResults = [];
  }

  handleFilter(value) {
    debugger;
    if (value.length >= 2) {
      this.options = this.cascadeOptions.filter(
        (s) => s.text.toLowerCase().indexOf(value.toLowerCase()) !== -1
      );
    } else {
      this.options = this.cascadeOptions.slice();
      this.combo1?.toggle(false);
      this.combo2?.toggle(false);
      this.combo3?.toggle(false);
    }
  }
  // File Field
  openFileManager() {
    console.log('Opening file manager');
    const dialogRef = this.dialog.open(FileManagerComponent, {
      width: '80%',
      height: '80%',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('File manager closed', result);
      if (result) {
        this.baseData[this.fieldConfig.columnCode] = { id: result.id, fileName: result.fileName };
        this.onChange();
      }
    });
  }

  downloadFile(file: any) {
    const link = document.createElement('a');
    link.href = file.dataUrl;
    link.download = file.name;
    link.click();
  }

  removeFile() {
    console.log('Removing file');
    this.baseData[this.fieldConfig.columnCode] = null;
    this.onChange();
  }


  // Array Field
  ngDoCheck(): void {
    if (this.arrayData.length !== this.previousArrayDataLength) {
      console.log("Change detected in arrayData");
      this.updateBaseData(); // Call method to update baseData
      this.previousArrayDataLength = this.arrayData.length; // Update the previous length
    }
  }

  updateBaseData(): void {

    this.baseData[this.fieldConfig.columnCode] = this.arrayData.map(item => item.content);
    console.log("BaseData updated:", this.baseData[this.fieldConfig.columnCode]); // Logging for debugging
    this.valueChanged.emit({ field: this.fieldConfig.columnCode, value: this.baseData[this.fieldConfig.columnCode], isValid: this.fieldConfig.isValid });

  }


  onSelectionChange(event: any): void {
    console.log('Selected items:', event);
  }

  addNewItem(): void {
    if (this.newItem.trim()) {
      const newIndex = this.arrayData.length;
      this.arrayData.push({ content: this.newItem, index: newIndex });

      if (!this.baseData[this.fieldConfig.columnCode]) {
        this.baseData[this.fieldConfig.columnCode] = [];
      }
      this.baseData[this.fieldConfig.columnCode].push(this.newItem);

      this.newItem = '';

      this.valueChanged.emit({ field: this.fieldConfig.columnCode, value: this.arrayData, isValid: this.fieldConfig.isValid });
      console.log("array Data in addItem: ", this.arrayData);

    }
  }

  removeSelectedItems(): void {
    // Prepare an updated arrayData and baseData
    const updatedArrayData = [];
    const updatedBaseData = [];

    this.arrayData.forEach(item => {
      if (!this.selectedItems.find(selected => selected.index === item.index)) {
        // Item is not in the selectedItems, keep it in both arrays
        updatedArrayData.push(item);
        updatedBaseData.push(item.content);
      }
    });

    // Update arrayData and baseData with the non-removed items
    this.arrayData = updatedArrayData;
    this.baseData[this.fieldConfig.columnCode] = updatedBaseData;

    // Log the current state of baseData for debugging
    console.log('Updated baseData after removal:', this.baseData[this.fieldConfig.columnCode]);

    // Clear the selection
    this.selectedItems = [];

    console.log("array Data in removeItem: ", this.arrayData);

    // Emit the updated data
    this.valueChanged.emit({ field: this.fieldConfig.columnCode, value: this.arrayData, isValid: this.fieldConfig.isValid });
  }


  checkForRemovedItems(): void {
    if (this.baseData[this.fieldConfig.columnCode].length !== this.arrayData.length) {
      this.removeSelectedItems();
    }
  }


  // Object (JSON) CodeEditField
  loadFieldObjectIntoEditor(): void {
    if (this.baseData && this.baseData[this.fieldConfig.columnCode]) {
      try {
        this.editorContent = JSON.stringify(this.baseData[this.fieldConfig.columnCode], null, 2);
        console.log('Loaded JSON into editor:', this.editorContent);
      } catch (e) {
        console.error('Error converting FieldObject to JSON string:', e);
      }
    }
  }
  private editorChangeTimeout: any;
  onMonacoInit(editorInstance: any): void {
    editorInstance.onDidChangeModelContent(() => {
      clearTimeout(this.editorChangeTimeout);
      this.editorChangeTimeout = setTimeout(() => {
        this.onCodeEditorChange(editorInstance.getValue());
      }, 300);
    });
  }

  onCodeEditorChange(value: string): void {
    try {
      const parsedValue = JSON.parse(value);
      const column = (this.fieldConfig?.columnCode || '').toLowerCase();
      const isArgsField = column === 'args';

      // Deve essere un oggetto o, se Args, può essere anche un array
      const isAcceptableObject = parsedValue && typeof parsedValue === 'object' && !Array.isArray(parsedValue);
      const isAcceptableArray = isArgsField && Array.isArray(parsedValue);

      if (isAcceptableObject || isAcceptableArray) {
        // Inizializza il contenitore
        this.baseData[this.fieldConfig.columnCode] = isAcceptableArray ? [] : {};

        if (isAcceptableArray) {
          // Per Args accettiamo l'array "as is"
          this.baseData[this.fieldConfig.columnCode] = parsedValue;
        } else {
          // Per oggetti manteniamo la logica esistente
          Object.keys(parsedValue).forEach(key => {
            const val = parsedValue[key];
            if (
              typeof val === 'string' ||
              typeof val === 'number' ||
              Array.isArray(val) ||
              typeof val === 'object'
            ) {
              this.baseData[this.fieldConfig.columnCode][key] = val;
            } else {
              console.error(`Unsupported data type for key ${key}:`, val);
            }
          });
        }

        console.log('BaseData updated with object/array:', this.baseData[this.fieldConfig.columnCode]);
        this.valueChanged.emit({ field: this.fieldConfig.columnCode, value: this.arrayData, isValid: this.fieldConfig.isValid });
      } else {
        console.error(
          isArgsField
            ? 'Invalid JSON structure. Expected an object or array for Args.'
            : 'Invalid JSON structure. Expected an object.'
        );
      }
    } catch (e) {
      console.error('Error parsing JSON:', e);
    }
  }


}
